module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team fk__team"
  }, [_c('div', {
    staticClass: "fk__team__bg--texture"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__team__bg--orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__team__gradient"
  }), _vm._v(" "), _c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__team__heading"
  }, [_vm._v("Our Mission")]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__container"
  }, [_c('div', {
    staticClass: "fk__team__info fk__team__info--main"
  }, [_c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Famous King's mission is to share who the one true God is to the world and to help make him famous by using film and creative media.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Our vision is that Famous King would help engage people in making God famous through projects such as promotional videos for non-profit organizations who are actively expressing who God is through their existing work, documentaries expressing characteristics of God and how he works with his people, as well as narrative works of fiction that help express God's characteristics and truth in the lives of his people.")]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__info__image-container"
  }, [_c('img', {
    staticClass: "fk__team__info__image",
    attrs: {
      "src": require("../assets/team/missionFeature.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "fk__team__info__image",
    attrs: {
      "src": require("../assets/team/famousKingLogo.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Famous King is committed to producing works with excellence and with a cost-effective mindset. Video production can be a costly process and can result in big budgets and with lots of expenses. Famous King is committed to using a thoughtful and prayerful process to create the most impactful products with a minimum amount of cost.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("The Famous King team is looking for partners who are making an impact for the Kingdom. We will ambitiously team up to produce creative media that will make God famous to the nations.")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__member"
  }, [_c('img', {
    staticClass: "fk__team__member__head",
    attrs: {
      "src": require("../assets/team/kent.jpg")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fk__team__member__email",
    attrs: {
      "href": "mailto:kent.broddle@famousking.com"
    }
  }, [_c('img', {
    staticClass: "fk__team__member__email--icon",
    attrs: {
      "src": require("../assets/mail.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__member__info"
  }, [_c('h3', {
    staticClass: "fk__team__member__info--name"
  }, [_vm._v("Kent Broddle")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--position"
  }, [_vm._v("President")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("Kent Broddle has worked at Garmin International for the last 25 years as a software engineer and engineering leader. He has been assigned to many interesting products including automotive infotainment, mobile phones, digital radios, GPS equipped PDAs, aviation navigation devices, and GPS surveying equipment. His travels have taken him to many leading cultural centers such as London, Beijing, Shanghai, Taipei, and Barcelona. Kent has been an integral part of this world-wide, world-class company and has learned valuable lessons in product development, process structure, and large team organization.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("\nKent’s passion for starting Famous King started while travelling internationally. During one of the long flights to-from Taipei, God provided overwhelming inspiration to startup a film company whose mission would be to make Him famous. After many conversations and much soul searching, a team began to form that shared much of this same passion. Several years later, God has guided us to this tipping point… we want to share who the one true God is to the world and to help make him famous by using film and creative media.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("Kent has been married to his wife, Tonya, for 30 years and have 3 grown children. Kent and Tonya have been serving at Foundry Church in Lenexa, Kansas. During his free time Kent enjoys many activities and hobbies including basketball, softball, biking, playing games, watching sports, and spending time with family and friends.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d85c799c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mission.vue
// module id = 82
// module chunks = 0